//@ts-check

/**
 * Get default ky options for API requests
 *
 * Returns standard options for login API requests
 *
 * @param {Object} [overrides] - Optional overrides for standard options
 * @param {number} [overrides.timeout=10000] - Request timeout in milliseconds
 * @param {boolean} [overrides.log=true] - Log requests to console
 * @returns {import('ky').Options} Default ky options
 */
export function getKyOptions(overrides = {}) {
  const { timeout = 10000, log = true } = overrides;

  /** @type {import('ky').Options} */
  const options = {
    timeout,
  };

  // Add logging hook if enabled
  if (log) {
    options.hooks = {
      beforeRequest: [
        /** @param {{ request: Request }} state */
        ({ request }) => {
          console.log("API Request:", request.method, request.url);
        },
      ],
    };
  }

  return options;
}
